module.exports = __webpack_public_path__ + "static/img/BreakYourCreativeBlock-sm.10e096c.png";